const UNIT_ID_COOKIE_NAME = 'unit_id'
const EXPIRE_DAYS = 365

export { EXPIRE_DAYS, UNIT_ID_COOKIE_NAME }
